import script from "./BaseDatepicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDatepicker.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDatepicker.vue?vue&type=style&index=0&id=06e2404d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e2404d"]])

export default __exports__